/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CompanyType {
    ASSOCIATION = 'association',
    COOPERATIVE = 'cooperative',
    CORPORATION = 'corporation',
    DESIGNATED_ACTIVITY_COMPANY = 'designated_activity_company',
    ENTREPRENEURIAL_COMPANY = 'entrepreneurial_company',
    EXTRA_PROVINCIAL_CORPORATION = 'extra_provincial_corporation',
    FOUNDATION = 'foundation',
    GENERAL_PARTNERSHIP = 'general_partnership',
    INCORPORATED_LIMITED_PARTNERSHIP = 'incorporated_limited_partnership',
    JOINT_VENTURE = 'joint_venture',
    LIMITED_BY_GUARANTEE = 'limited_by_guarantee',
    LIMITED_LIABILITY_COMPANY = 'limited_liability_company',
    LIMITED_LIABILITY_PARTNERSHIP = 'limited_liability_partnership',
    LIMITED_PARTNERSHIP = 'limited_partnership',
    LIMITED_PARTNERSHIP_ON_SHARES = 'limited_partnership_on_shares',
    PRIVATE_LIMITED_COMPANY = 'private_limited_company',
    PROPRIETARY_LIMITED_COMPANY = 'proprietary_limited_company',
    PUBLIC_LIMITED_COMPANY = 'public_limited_company',
    REGISTERED_MERCHANT = 'registered_merchant',
    SIMPLIFIED_STOCK_CORPORATION = 'simplified_stock_corporation',
    SOLE_TRADER = 'sole_trader',
    TRUST = 'trust',
    UNLIMITED_COMPANY = 'unlimited_company',
    OTHER = 'other',
}
